import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

// hero page animations
export const startMarqueeAnimation = (ref) => {
  if (!ref.current) return null;

  return gsap.to(ref.current, {
    backgroundPosition: "200% center",
    duration: 3.5,
    ease: "none",
    repeat: -1,
    repeatDelay: 4,
  });
};

export const startHeroBackgroundAnimation = (ref) => {
  if (!ref.current) return null;

  const mm = window.matchMedia("(min-width: 576px)");

  if (!mm.matches) return null;

  return gsap.to(ref.current, {
    yPercent: -15,
    scale: 1.08,
    ease: "none",
    transformOrigin: "center center",
    scrollTrigger: {
      trigger: ref.current.closest(".banner-section"),
      start: "top top",
      end: "bottom top",
      scrub: 1.2,
      invalidateOnRefresh: true,
    },
  });
};

export const startGlobeParallaxAnimation = (ref) => {
  if (!ref.current) return null;

  const mm = window.matchMedia("(min-width: 576px)");

  if (!mm.matches) return null;

  return gsap.to(ref.current, {
    yPercent: 15, // Reduced parallax effect (was 40)
    ease: "none",
    scrollTrigger: {
      trigger: ref.current.closest(".banner-section"),
      start: "top top",
      end: "bottom top",
      scrub: 1.5, // Super smooth scrub
      invalidateOnRefresh: true,
    },
  });
};

export const startHeroEntryAnimation = (ref, onComplete) => {
  if (!ref.current) return null;

  const elements = ref.current.querySelectorAll(".hero-entry-item");

  gsap.set(elements, {
    y: 25,
    opacity: 0,
  });

  return gsap.to(elements, {
    y: 0,
    opacity: 1,
    duration: 0.7,
    ease: "power3.out",
    stagger: 0,
    onComplete,
  });
};

export const cleanupAnimation = (animation) => {
  if (!animation) return;

  animation.scrollTrigger?.kill();
  animation.kill();
};

export const trustShineSx = (color) => ({
  display: "inline",
  color,
  fontSize: {
    xs: "3rem",
    sm: "3.5rem",
    md: "4rem",
    lg: "4.5rem",
  },
  fontWeight: 800,
  lineHeight: 1,
  background: `linear-gradient(110deg, ${color} 35%, #fff 50%, ${color} 65%)`,
  backgroundSize: "250% 100%",
  backgroundPosition: "100% 0",
  backgroundClip: "text",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  animation: "trustShine 5s ease-in-out infinite",
  "@keyframes trustShine": {
    "0%": {
      backgroundPosition: "100% 0",
    },
    "15%": {
      backgroundPosition: "0% 0",
    },
    "100%": {
      backgroundPosition: "0% 0",
    },
  },
});



// hero Action Animations

export const heroArrowAnimation = {
  "&:hover .hero-arrow svg": {
    animation: "heroArrowSlide 0.7s ease-in-out",
  },
  "@keyframes heroArrowSlide": {
    "0%": {
      transform: "translateX(0)",
      opacity: 1,
    },
    "35%": {
      transform: "translateX(45px)",
      opacity: 0,
    },
    "36%": {
      transform: "translateX(-45px)",
      opacity: 0,
    },
    "70%": {
      transform: "translateX(-15px)",
      opacity: 0.35,
    },
    "100%": {
      transform: "translateX(0)",
      opacity: 1,
    },
  },
};




// hero state animations

export const startHeroStatsAnimation = (stats, setDisplayValues) => {
  const targets = stats.map((stat) => Math.max(0, Number(stat.value) || 0));
  const startTime = performance.now();
  const duration = 2000;
  let frame;

  const animate = (currentTime) => {
    const progress = Math.min((currentTime - startTime) / duration, 1);
    const eased = 1 - Math.pow(1 - progress, 3);
    setDisplayValues(targets.map((target) => Math.floor(target * eased)));

    if (progress < 1) {
      frame = requestAnimationFrame(animate);
    } else {
      setDisplayValues(targets);
    }
  };

  frame = requestAnimationFrame(animate);

  return () => {
    if (frame) cancelAnimationFrame(frame);
  };
};